import { AxiosResponse } from 'axios';
import { Setting } from 'src/admin-entity/interface/setting/setting.interface';
import { BASE_URL } from 'src/config/api';
import client from '../client';
import { InvoiceTopicItem } from 'src/admin-entity/interface/setting/invoice-topic-item.zod';
import { InvoiceTemplate } from 'src/admin-entity/interface/setting/invoice-template.zod';
import { InvoiceTemplateSimple } from 'src/admin-entity/interface/setting/invoice-template-simple.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { DeliveryItemDelimiterOption } from 'src/admin-entity/enum/distributor/delivery-item-delimiter-option.enum';
import { ProductTopMessageOption } from 'src/admin-entity/interface/setting/product-top-message-option.interface';

export const getPGSettings = (): Promise<AxiosResponse<Setting>> => {
    return client.get(`${BASE_URL}/v1/admin/settings/selected-pg`);
};

export const updatePGSetting = (setting: Setting): Promise<AxiosResponse<Setting>> => {
    return client.put(`${BASE_URL}/v1/admin/settings/selected-pg`, setting);
};

export const getInvoiceFieldList = (): Promise<AxiosResponse<InvoiceTopicItem[]>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/fields/simple`);
};

export const registerInvoiceTemplate = (template: InvoiceTemplate): Promise<AxiosResponse<InvoiceTemplate>> => {
    return client.post(`${BASE_URL}/v1/admin/purchase-order/template`, template);
};

export const getInvoiceTemplateList = (
    page: number,
    take: number,
    title?: string,
): Promise<AxiosResponse<Page<InvoiceTemplate>>> => {
    return client.get(
        `${BASE_URL}/v1/admin/purchase-order/template?take=${take}&page=${page}${title ? `&title=${title}` : ``}`,
    );
};

export const getInvoiceTemplateSimpleList = (): Promise<AxiosResponse<InvoiceTemplateSimple[]>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/template/simple`);
};

export const deleteInvoiceTemplate = (id: number): Promise<AxiosResponse<boolean>> => {
    return client.delete(`${BASE_URL}/v1/admin/purchase-order/template/${id}`);
};

export const getInvoiceTemplateDetail = (id: number): Promise<AxiosResponse<InvoiceTemplate>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/template/${id}`);
};

export const updateInvoiceTemplate = (
    id: number,
    template: InvoiceTemplate,
): Promise<AxiosResponse<InvoiceTemplate>> => {
    return client.put(`${BASE_URL}/v1/admin/purchase-order/template/${id}`, template);
};

export const applyInvoiceTemplate = (distributorId: number, templateId: number): Promise<AxiosResponse<boolean>> => {
    return client.put(`${BASE_URL}/v1/admin/purchase-order/template/${templateId}/distributor/${distributorId}`);
};

export const updateDeliveryItemDelimiterOption = (
    distributorId: number,
    deliveryItemDelimiterOption: DeliveryItemDelimiterOption,
): Promise<AxiosResponse<boolean>> => {
    return client.put(`${BASE_URL}/v1/admin/distributors/${distributorId}/setting`, {
        deliveryItemDelimiterOption,
    });
};

export const getProductTopMessageOption = (): Promise<AxiosResponse<ProductTopMessageOption>> => {
    return client.get(`${BASE_URL}/v1/admin/settings/purchase-prompt`);
};

export const updateProductTopMessageOption = (
    option: ProductTopMessageOption,
): Promise<AxiosResponse<ProductTopMessageOption>> => {
    return client.put(`${BASE_URL}/v1/admin/settings/purchase-prompt`, option);
};
